/**
 * Should a 1:1 video call auto-pause the camera for CarPlay / Android Auto?
 *
 * Both car-mode pause triggers in `use-voice-call-controller` route through
 * this guard: the car attach/detach effect and the end-of-resume reconcile.
 *
 * The driver override exists because of the #546 bug: tapping
 * "I've stopped — turn video on" cleared `selfDriving`, but the phone normally
 * stays connected to the car while parked, so the reconcile immediately
 * re-paused the camera — the button never worked in its primary scenario.
 * An override is recorded per callId when the driver explicitly taps, and is
 * cleared when the car actually detaches (the next attach means driving again).
 */
export type CarVideoPauseGuardInput = {
  /** Live CarPlay / Android Auto connection state. */
  carConnected: boolean
  /** The session is already in the driving pause. */
  selfDriving: boolean
  /** callId the driver explicitly overrode with "I've stopped", or null. */
  overrideCallId: string | null
  /** The call being evaluated. */
  callId: string
}

export function shouldAutoPauseVideoForCar(input: CarVideoPauseGuardInput): boolean {
  if (!input.carConnected) return false
  if (input.selfDriving) return false
  return input.overrideCallId !== input.callId
}
